// extracted by mini-css-extract-plugin
export default {"title":"ToastLayout_title__dSr7P","text":"ToastLayout_text__H0UWu"};